export const UMB_DOCUMENT_USER_PERMISSION_CONDITION_ALIAS = 'Umb.Condition.UserPermission.Document';
